import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { translates } from '@/utils';
import { Button } from '@PorkyCol/button';
import { changeStatusReservation } from '@/services/reservations';

type Props = {
  id: string;
  isOpen: boolean;
  handleClose: () => void;
};
const STATUS = ['PENDING', 'ACCEPTED', 'PAID', 'CANCELED', 'REJECTED'];

export const ModalChangeStatusReservation = ({ id, handleClose, isOpen }: Props) => {
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation({
    mutationFn: changeStatusReservation(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['reservations'] });
    },
  });

  const handleChangeStatus = async () => {
    await mutateAsync({ status: selected });
    handleClose();
  };

  const [selected, setSelected] = useState('Seleccione un estado');

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogTitle>Cambio de estado de la Reserva</DialogTitle>

      <DialogContent sx={{ display: 'flex', padding: '1rem' }}>
        <FormControl fullWidth sx={{ m: 1 }}>
          <InputLabel id="demo-simple-select-label">{translates.status}</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="estados"
            onChange={(event: any) => setSelected(event.target.value)}
          >
            {STATUS.map((status, key) => (
              <MenuItem value={status} key={key}>
                {status}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Box sx={{ display: 'flex', gap: '1rem' }}>
          <Button color="secondary" variant="outline" onClick={handleClose}>Cancelar</Button>
          <Button color="success" onClick={handleChangeStatus}>Guardar</Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
